import styled from "styled-components";

const StyledVideoCard = styled.div`
  display: flex;
  flex-direction: column;
  font-size: calc(1rem + .25vw);
  line-height: 1;

  .card-16-9-ratio {
    position: relative;
    padding-top: 56.25%;
  }
  
  .image-16-9-ratio {
    position: absolute;
    left: 0;
    top: 0;
    right: auto;
    bottom: auto;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .webpage-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .webpage-link {
    padding: 0.5rem;
    border-radius: 0.75rem;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-decoration: none;
  }

  .webpage-link:hover {
    background-color: red;
  }

  .video_label {
    padding: 0.5rem;
    background-color: #fff;
    text-align: center;
  }

`

export default StyledVideoCard;